










import { Component, Mixins } from "vue-property-decorator";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { ImageCaptureDialog } from "./dialogs";
import { FatalIndicator } from "./common";
import { IExecutable } from "./IExecutable";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";

@Component({
  components: {
    ImageCaptureDialog,
    FatalIndicator,
  }
})
export default class WizardContentImageCaptureInput extends Mixins(MediaSelectableContentMixin) implements IExecutable {
  $refs!: {
    capture: ImageCaptureDialog,
  };

  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "撮影";
  }

  async execute() {
    const result = await this.$refs.capture.show();
    if (!!result) {
      this.uploadImageFile(result);
    }
  }
}
